export const SET_USERINFO = 'SET_USERINFO';
export const SET_CARTNUM = 'SET_CARTNUM';
export const GET_USERINFO = 'GET_USERINFO';
export const GET_TARGETROUTE = 'GET_TARGETROUTE';
export const SET_FIRSTLOGININFO = 'SET_FIRSTLOGININFO';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js